export const DEFAULT_TEMPLATE_NAME = "Untitled Template"
